import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowError } from '../modals';

function onShowModal($modal, $ok) {
    const $spinner = $('#loadingVehicles');
    $spinner.show();
    fetch('/get-vehicles')
        .then(response => {
            $spinner.hide();
            if (!response.ok) {
                throw new Error("Kunne ikke hente køretøjer");
            }
            return response.json();
        })
        .then(json => {
            if (!json.success) {
                throw new Error(json.errorMessage);
            }
            onVehicles($modal, $ok, json.vehicles);
        })
        .catch(error => {
            fdsShowError($modal, error.message ?? error);
            $ok.hide();
        });
}

function onHideModal($modal, $ok) {
    const $vehicleList = $('#vehicleList');
    $vehicleList.find('tbody').html('');
    $vehicleList.hide();
    $ok.show();
    fdsReset($modal);
}

/**
 * @param {jQuery} $modal
 * @param {jQuery} $ok
 * @param {Array<{id: number, name: string, type: string, registration: string, trailers: string, documents: string, locked: boolean, expirationDate: string, expired: boolean}>} vehicles
 */
function onVehicles($modal, $ok, vehicles) {
    if (vehicles.length === 0) {
        fdsShowError($modal, 'Dit køretøjsregister er tomt. Du kan tilføje køretøjer under menupunktet \'Køretøjsregister\'.');
        $ok.hide();
        return;
    }

    const rows = vehicles
        .map(vehicle =>
            `<tr>
    <td>
        <div class="form-group-radio">
            <input type="radio" name="vehicleId" value="${vehicle.id}" class="form-radio" id="vehicle${vehicle.id}" 
                ${vehicle.expired ? 'disabled' : ''}>
            <label for="vehicle${vehicle.id}">
                <span class="sr-only">Vælg køretøjet '${vehicle.name}'</span>
            </label>
        </div>
    </td>
    <td><label for="vehicle${vehicle.id}">${vehicle.name}</label></td>
    <td><label for="vehicle${vehicle.id}">${vehicle.type}</label></td>
    <td><label for="vehicle${vehicle.id}">${vehicle.registration || ''}</label></td>
    <td><label for="vehicle${vehicle.id}">${vehicle.trailers || ''}</label></td>
    <td><label for="vehicle${vehicle.id}">${vehicle.expirationDate || ''}</label></td>
</tr>`
        )
        .join('');

    const $vehicleList = $('#vehicleList');
    $vehicleList.find('tbody').html(rows);
    $vehicleList.show();
}

function addVehicle($modal) {
    const vehicleId = $('input:radio:checked[name=vehicleId]').val();
    if (vehicleId) {
        new DKFDS.Modal($modal.get(0)).hide();
        $('input[name="caseBean.vehicleId"]').val(vehicleId).closest('form').submit();
    }
    else {
        fdsShowError($modal, 'Du har ikke valgt et køretøj');
    }
}

$(() => {
    const $modal = $('#addVehicleModal');
    const $ok = $('#addVehicleModalOK');
    $modal.get(0).addEventListener('fds.modal.shown', () => onShowModal($modal, $ok));
    $modal.get(0).addEventListener('fds.modal.hidden', () => onHideModal($modal, $ok));

    $ok.on('click', () => addVehicle($modal));
});
